const locale = {
    placeholder: 'เลือกเวลา',
};
export default locale;



// WEBPACK FOOTER //
// ./components/time-picker/locale/th_TH.tsx